import { combineReducers } from "@reduxjs/toolkit";
import appReducer from "./app/reducer";
import groupOperationsReducer from "./group-operations/reducer";
import ordersReducer from "./orders/reducer";
import modalReducer from "./modal/reducer";
import categoryReducer from "./category/reducer";
import menuReducer from "./menu/reducer";

export const rootReducer = combineReducers({
  app: appReducer,
  groupOperations: groupOperationsReducer,
  orders: ordersReducer,
  modal: modalReducer,
  category: categoryReducer,
  menu: menuReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
